import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SchemaOrg from '@/components/feature/SchemaOrg';
import { siteInfo, brandValues, reputationData } from '@/mocks/site-info';

export default function AboutPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SchemaOrg type="Organization" />
      <SchemaOrg
        type="WebPage"
        data={{
          name: `关于我们 - ${siteInfo.name}`,
          description: `${siteInfo.name}品牌介绍、口碑评价及联系方式，了解国内领先的免费在线视频观看平台`,
          url: `${siteInfo.url}/about`,
        }}
      />

      <Navbar />

      <main className="pt-16">
        <Breadcrumb
          items={[
            { label: '首页', href: '/' },
            { label: '关于我们' },
          ]}
        />

        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
          <div className="max-w-4xl mx-auto text-center">
            <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center rounded-2xl bg-primary-500">
              <i className="ri-play-circle-fill text-3xl text-white"></i>
            </div>
            <h1 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
              关于<strong>97视频</strong>
            </h1>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl mx-auto">
              97视频创立于{siteInfo.founded}，是国内领先的免费在线视频观看平台。
              我们致力于打破传统视频观看的壁垒，让每一位用户都能享受高品质、零成本的观影体验。
              经过多年发展，97视频已累计服务超过{siteInfo.stats.totalUsers}用户，
              成为国内最受欢迎的免费视频网站之一。
            </p>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
                品牌理念
              </h2>
              <p className="text-sm text-foreground-500 mt-2">四大核心价值，定义极致观影体验</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {brandValues.map((val, index) => (
                <div key={index} className="bg-background-50 rounded-xl p-6 text-center transition-all duration-300 hover:scale-[1.02]">
                  <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-primary-500/10">
                    <i className={`${val.icon} text-2xl text-primary-500`}></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-950 mb-2">{val.title}</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">{val.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
                平台口碑
              </h2>
              <p className="text-sm text-foreground-500 mt-2">数据说话，品质见证</p>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
              {reputationData.map((item, index) => (
                <div key={index} className="bg-background-100 rounded-xl p-5 text-center transition-all duration-300 hover:scale-[1.02]">
                  <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-500/10">
                    <i className={`${item.icon} text-lg text-accent-500`}></i>
                  </div>
                  <div className="text-xl md:text-2xl font-bold text-accent-500 mb-1">{item.value}</div>
                  <div className="text-xs text-foreground-500">{item.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
                联系我们
              </h2>
              <p className="text-sm text-foreground-500 mt-2">有任何问题？我们随时为您服务</p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              <div className="bg-background-50 rounded-xl p-6">
                <h3 className="text-lg font-semibold text-foreground-950 mb-6">联系方式</h3>
                <div className="flex flex-col gap-5">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-500/10 flex-shrink-0">
                      <i className="ri-mail-line text-lg text-primary-500"></i>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-950">电子邮箱</div>
                      <div className="text-sm text-foreground-600">{siteInfo.contact.email}</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-500/10 flex-shrink-0">
                      <i className="ri-phone-line text-lg text-primary-500"></i>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-950">客服电话</div>
                      <div className="text-sm text-foreground-600">{siteInfo.contact.phone}</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-500/10 flex-shrink-0">
                      <i className="ri-map-pin-line text-lg text-primary-500"></i>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-950">公司地址</div>
                      <div className="text-sm text-foreground-600">{siteInfo.contact.address}</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-500/10 flex-shrink-0">
                      <i className="ri-wechat-line text-lg text-primary-500"></i>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-950">微信公众号</div>
                      <div className="text-sm text-foreground-600">{siteInfo.contact.wechat}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-background-50 rounded-xl p-6">
                <h3 className="text-lg font-semibold text-foreground-950 mb-6">发送消息</h3>
                <form
                  id="contact-form-97video"
                  data-readdy-form
                  method="POST"
                  action="https://readdy.ai/api/form/d9mutu0bdkpk99j7geg0"
                  acceptCharset="UTF-8"
                  className="flex flex-col gap-4"
                >
                  <input type="hidden" name="form_name" value="97视频联系方式" />
                  <div>
                    <label htmlFor="contact-name" className="block text-xs font-medium text-foreground-700 mb-1.5">
                      姓名
                    </label>
                    <input
                      type="text"
                      id="contact-name"
                      name="name"
                      required
                      className="w-full px-4 py-2.5 bg-background-100 border border-background-200 rounded-lg text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-500 transition-colors"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-email" className="block text-xs font-medium text-foreground-700 mb-1.5">
                      邮箱
                    </label>
                    <input
                      type="email"
                      id="contact-email"
                      name="email"
                      required
                      className="w-full px-4 py-2.5 bg-background-100 border border-background-200 rounded-lg text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-500 transition-colors"
                      placeholder="请输入您的邮箱"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-message" className="block text-xs font-medium text-foreground-700 mb-1.5">
                      留言
                    </label>
                    <textarea
                      id="contact-message"
                      name="message"
                      required
                      maxLength={500}
                      rows={4}
                      className="w-full px-4 py-2.5 bg-background-100 border border-background-200 rounded-lg text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-500 transition-colors resize-none"
                      placeholder="请输入您的留言（500字以内）"
                    ></textarea>
                  </div>
                  <div className="contact-honeypot-wrapper">
                    <input
                      type="text"
                      name="phone_alt"
                      tabIndex={-1}
                      autoComplete="off"
                      aria-hidden="true"
                      readOnly
                      className="contact-honeypot-field"
                    />
                  </div>
                  <button
                    type="submit"
                    className="w-full py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-lg text-sm transition-colors cursor-pointer whitespace-nowrap"
                  >
                    发送消息
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}